import React from 'react';
import FormSection from '../../../../components/atom/FormSection';
import FormikInput from '../../../../components/atom/FormikInput';
import AliceTester from './AliceTester';

export default function ClientEditAlice({ values, setFieldValue }) {
    return (
        <FormSection title="Alice integration">
            <FormikInput name="aliceApikey" label="Alice Apikey" sm={12} />
            <FormikInput name="aliceUsername" label="Alice Username" />
            <FormikInput name="alicePassword" label="Alice Password" />
            <FormikInput sm={2} xs={2} name="aliceHotelId" label="Hotel Id" />
            <FormikInput sm={2} xs={2} name="aliceFacilityId" label="Facility Id" />
            <FormikInput sm={2} xs={2} name="aliceServiceId" label="Service Id" />
            <FormikInput sm={2} xs={2} name="aliceStatusCreateId" label="Create StatusId" />
            <FormikInput sm={2} xs={2} name="aliceStatusCancelId" label="Cancel StatusId" />
            <AliceTester
                apikey={values.aliceApikey}
                user={values.aliceUsername}
                pass={values.alicePassword}
                setAliceParams={(hotelId, facilityId, serviceId) => {
                    setFieldValue('aliceHotelId', hotelId);
                    setFieldValue('aliceFacilityId', facilityId);
                    setFieldValue('aliceServiceId', serviceId);
                }}
                setStatusCreateId={id => setFieldValue('aliceStatusCreateId', id)}
                setStatusCancelId={id => setFieldValue('aliceStatusCancelId', id)}
            />
        </FormSection>
    );
}
